import { render, staticRenderFns } from "./PantallaCarga.vue?vue&type=template&id=171b2aec"
import script from "./PantallaCarga.vue?vue&type=script&lang=js"
export * from "./PantallaCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports